import api from "@helpers/api";

import { URLS } from "@constants/urls";
import { STATUS } from "@constants/status.hrm";

import { LeaveType } from "@type/HRM/leave-type";

const { LEAVE, BALANCE, EMPLOYEES } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPointBaseURL = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${LEAVE}`;

export const getLeaveBalance = (() => {
  return async (employeeId: string): Promise<{ data: LeaveType[] }> => {
    return api
      .get(`${apiEndPointBaseURL}/${BALANCE}/${EMPLOYEES}/${employeeId}`)
      .then((response) => {
        return { data: response.data.data };
      });
  };
})();

export const updateLeaveBalance = (() => {
  return async (
    employeeId: string,
    data: LeaveType[],
    afterEffect: (param: any) => void,
  ): Promise<{ data: LeaveType[] }> => {
    const transformedData = data.map((item: LeaveType) => ({
      leaveTypeId: Number(item.leaveTypeId),
      totalLeaveCount: Number(item.totalLeaveCount),
      takenLeaveCount: Number(item.takenLeaveCount),
    }));

    return api
      .post(
        `${apiEndPointBaseURL}/${BALANCE}/${EMPLOYEES}/${employeeId}`,
        transformedData,
      )

      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const getLeaveResetValue = (() => {
  return async () => {
    return api.get(`${apiEndPointBaseURL}/reset/button`).then((response) => {
      return { data: response.data };
    });
  };
})();

export const resetLeaveBalance = (() => {
  return async (afterEffect: (param: any) => void) => {
    return api
      .put(`${apiEndPointBaseURL}/${BALANCE}/reset`)
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
